// template.service.ts
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class TemplateService {

    constructor(private http: HttpClient) { }
    getTemplatesByType(type: string, queryParams?: any) {
        let params = new HttpParams();
        if (queryParams.page) {
            params = params.set('page', queryParams.page);
        }
        if (queryParams.limit) {
            params = params.set('limit', queryParams.limit);
        }
        if (queryParams.sortField) {
            if (queryParams.sortField == 'name') {
                queryParams.sortField = 'first_name';
            }
            params = params.set('sortField', queryParams.sortField);
        }
        if (queryParams.sortOrder) {
            params = params.set('sortOrder', queryParams.sortOrder);
        }
        return this.http.get<any>(`${environment.baseUrl}twilio-sms-template/${type}`, { params });
    }

    createTemplate(templateData: any) {
        return this.http.post<any>(`${environment.baseUrl}twilio-sms-template/create-template`, templateData);
    }

    updateTemplate(id: string, data: string) {
        return this.http.patch<any>(`${environment.baseUrl}twilio-sms-template/update-template/${id}`, data);
    }

    deleteTemplate(templateId: string): Observable<any> {
        return this.http.delete<any>(`${environment.baseUrl}twilio-sms-template/${templateId}`);
    }

    getSystemConversation(tourId: string, fromRole: string, toRole: string) {
        return this.http.get<any>(`${environment.baseUrl}twilio-conversation/conversation`, {
            params: {
                tourId,
                fromRole,
                toRole
            }
        });
    }

    getConversation(tourId: string, fromRole: string, toRole: string) {
        return this.http.get<any>(`${environment.baseUrl}twilio-conversation`, {
            params: {
                tourId,
                fromRole,
                toRole
            }
        });
    }

    getResidentVisitorConversation(tourId: string) {
        return this.http.get<any>(`${environment.baseUrl}twilio-conversation/resident-visitor`, {
            params: { tourId }
        });
    }

    getLastSortOrder(sendTo: string): Observable<number> {
        return this.http.get<number>(`${environment.baseUrl}twilio-sms-template/${sendTo}/lastSortOrder`);
    }
}